import web from "../web";

class CalendriersevaluationsService {
    index(token){
        return web.get("/api/calendriersevaluations", { headers: { 'Authorization': 'Bearer '+token } })
    }
    store(data, token){
        return web.post("/api/calendriersevaluations", data, { headers: { 'Authorization': 'Bearer '+token } })
    }

    show(id,token){
        return web.get(`/api/calendriersevaluations/${id}`,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    update(data,token){
        return web.put("/api/calendriersevaluations/update", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    delete(id,token){
        return web.delete(`/api/calendriersevaluations/${id}/delete`,{ headers: { 'Authorization': 'Bearer '+token } })
    }
}

export default new CalendriersevaluationsService()